module.exports = __webpack_public_path__ + "media/images/icon-download-0320462b4956dd077455e9baebefe0d1.svg";